import type { ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import { ReturnDealsToPipeline } from '@crm/features';
import { getPluralized } from '@crm/shared/lib';

import type { TDealDetails, TDealStatus } from '@crm/entities/deal';

interface DealStatusProps {
    dealDetailsData: TDealDetails;
}

export const DealStatus = ({ dealDetailsData }: DealStatusProps) => {
    const { t } = useTranslation();
    const statusMapping: Record<TDealStatus, ReactNode> = {
        postponed: (
            <div className="rounded-lg bg-smtr-main-green-10 px-3 py-2 text-xs leading-4 font-medium text-smtr-main-green-100">
                {t('crm.common.dealStatus.postponed')}
            </div>
        ),
        active: (
            <ReturnDealsToPipeline
                dealIds={[dealDetailsData.dealData.id]}
                columns={dealDetailsData.pipelineColumnsData.columns}
            />
        ),
        lost: (
            <div className="rounded-lg bg-neutral-100 px-3 py-2 text-xs leading-4 font-medium text-smtr-main-tertiary-100">
                {t('crm.common.dealStatus.lost')}
            </div>
        ),
        'in_work_or_finished': (
            <div className="rounded-lg bg-smtr-main-accent-50 px-3 py-2 text-xs leading-4 font-medium text-smtr-main-accent-100">
                {t('crm.common.dealStatus.inWorkOrFinished')}
            </div>
        ),
    };

    return (
        <div className="flex items-center gap-3">
            {statusMapping[dealDetailsData.dealData.status]}
            {dealDetailsData?.dealData?.status !== 'lost' && (
                <div className="text-xs leading-4 text-smtr-main-tertiary-100">
                    {t('crm.common.dealStatus.duration', {
                        duration: getPluralized(dealDetailsData?.dealData?.statusDaysCount, {
                            one: t('common.plurals.day.one'),
                            few: t('common.plurals.day.few'),
                            many: t('common.plurals.day.many'),
                        }),
                    })}
                </div>
            )}
        </div>
    );
};
